import {Status} from './status';

export type RendererState='loading'|'unknown'|'missing'|'refused'|'stale';

const descriptions:Record<RendererState,string>={
  loading:'Current truth is still being acquired.',
  unknown:'The requested posture is not known.',
  missing:'Required evidence is explicitly absent.',
  refused:'The requested carrier did not satisfy its boundary.',
  stale:'A newer posture may exist; the last known value remains timestamped.'
};

export function RendererStateView({
  state,title,detail
}:{
  state:RendererState;
  title:string;
  detail?:string;
}){
  return <section
    className="application-view view-state renderer-state"
    role={state==='refused'?'alert':'status'}
    aria-busy={state==='loading'}
    data-renderer-state={state}
  >
    <Status value={state}/>
    <h1>{title}</h1>
    <p>{detail||descriptions[state]}</p>
  </section>;
}
